// src/pages/DateInput.jsx (또는 .js)
import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ko } from 'date-fns/locale';
import { format, parseISO, isValid } from 'date-fns';

const DateInput = ({
  value,                 // string('yyyy-MM-dd') | Date | null
  onChange,              // (val: 'yyyy-MM-dd' | '') => void
  portalId = 'portal-root',
  placeholder = '날짜 선택',
  disabled = false,
}) => {
  const [selectedDate, setSelectedDate] = useState(null);
 
  useEffect(() => {
    if (!value) { setSelectedDate(null); return; }

    if (value instanceof Date) {
      setSelectedDate(isValid(value) ? value : null);
      return;
    }

    if (typeof value === 'string') { 
      const parsed = parseISO(value);
      setSelectedDate(isValid(parsed) ? parsed : null);
      return;
    }

    setSelectedDate(null);
  }, [value]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    if (onChange) {
      const formatted = date && isValid(date) ? format(date, 'yyyy-MM-dd') : '';
      onChange(formatted);
    }
  };

  return ( 
    <div className="date-input">
      <DatePicker
        selected={selectedDate}
        onChange={handleDateChange}
        dateFormat="yyyy-MM-dd"
        placeholderText={placeholder}
        locale={ko}
        disabled={disabled}
 
        portalId={portalId}
        popperPlacement="bottom-start"
        showPopperArrow={false}
      />
    </div>
  );
};

export default DateInput;